<div class="container">
  <form *ngIf="itemForm" [formGroup]="itemForm" (ngSubmit)="submit()" (keydown.enter)="$event.preventDefault()">
    <div class="header-container">
      <div class="button-container">
        <button type="button" mat-raised-button color="accent" (click)="$event.preventDefault(); close()" aria-label="Voltar">
          <mat-icon>arrow_back</mat-icon>
          <ng-container *ngIf="!layoutConf.isMobile">{{ "VOLTAR" | translate }}</ng-container>
        </button>
        <button type="button" mat-raised-button color="primary" [matTooltip]="'Salvar Produto'" [disabled]="isSaving" (click)="save(); $event.preventDefault()" aria-label="Salvar produto">
          <mat-icon>{{ isSaving ? 'hourglass_empty' : 'save' }}</mat-icon>
          <ng-container *ngIf="!layoutConf.isMobile">{{ isSaving ? 'SALVANDO...' : ('SAVE' | translate) }}</ng-container>
        </button>
        <button type="button" mat-raised-button color="primary" [matMenuTriggerFor]="menu" aria-label="Mais opções">
          <mat-icon>more_vert</mat-icon>
          <ng-container *ngIf="!layoutConf.isMobile">Mais Opções</ng-container>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="openAnexoUploadListPopUp(produto); $event.preventDefault();"
                  matTooltip="Migração em andamento">
            <mat-icon>attachment</mat-icon> Anexos/Imagens
            <mat-icon class="migration-indicator" matTooltip="Sistema moderno com armazenamento em nuvem (S3)">cloud_upload</mat-icon>
          </button>
          <button mat-menu-item (click)="openCodbarPopUp(produto); $event.preventDefault();">
            <mat-icon>qr_code</mat-icon> Código de Barras
          </button>
          <button mat-menu-item (click)="openMovtoPopUp(produto); $event.preventDefault();">
            <mat-icon>storage</mat-icon> Movimentações
          </button>
          <button mat-menu-item (click)="openTribPopUp(produto); $event.preventDefault();">
            <mat-icon>percentage</mat-icon> Tributação
          </button>
          <button mat-menu-item (click)="openPrecoPopUp(produto); $event.preventDefault();">
            <mat-icon>monetization_on</mat-icon> Preços
          </button>
          <button mat-menu-item (click)="openImagesPopUp(produto); $event.preventDefault();"
                  matTooltip="Migração em andamento (Usar Opcao Anexo/Imagens)">
            <mat-icon>image</mat-icon> Imagens/Foto
            <mat-icon class="migration-indicator" matTooltip="Usar Opcao Anexo/Imagens">cloud_upload</mat-icon>
          </button>
        </mat-menu>
      </div>
    </div>

    <!-- Conteúdo Principal -->
    <div class="form-content">
      <div class="form-container">
        <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px" fxLayoutGap.lt-md="8px" class="tab-content">
          <!-- Dados Básicos -->
          <mat-card fxFlex="100" class="section-card">
            <mat-card-title>{{ layoutConf.isMobile ? 'Dados Básicos' : 'Cadastro de Produto - Dados Básicos' }}</mat-card-title>
            <mat-card-content>
              <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px" fxLayoutGap.lt-md="8px">
                <div fxFlex="50" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Descrição</mat-label>
                    <input [imask]="maskUpper" matInput name="descricao" type="text" [formControl]="fc('descricao')" />
                    <mat-error *ngIf="itemForm?.controls['descricao']?.hasError('required') && itemForm?.controls['descricao']?.touched">
                      Descrição é obrigatória
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex="25" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Grupo/Categoria</mat-label>
                    <mat-select #grupoSelect [formControl]="fc('fatGrupoprodutos')" [compareWith]="compareFn" (selectionChange)="onSelectionChangeGrupo($event)" (openedChange)="onGrupoOpenedChange($event)">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="fc('searchGrupo')" placeholderLabel="Pesquisar Grupo/Categoria..."
                          noEntriesFoundLabel="Grupo/Categoria não encontrado" [searching]="searching"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let grupo of grupos" [value]="grupo">
                        {{ (grupo?.id ?? 0).toString().padStart(3, '0') }} - {{ (grupo?.descricao || '').trim() }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="25" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Marca</mat-label>
                    <mat-select #marcaSelect [formControl]="fc('fatMarca')" [compareWith]="compareFn" (selectionChange)="onSelectionChangeMarca($event)" (openedChange)="onSelectOpenedChange('searchMarca', $event)">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="fc('searchMarca')" placeholderLabel="Pesquisar Marca..."
                          noEntriesFoundLabel="Marca não encontrado" [searching]="searching"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let marca of fatMarcas" [value]="marca">
                        {{ (marca?.id ?? '').toString().padStart(3, '0') }} - {{ (marca?.descricao || '').trim() }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="25" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Tipo</mat-label>
                    <mat-select [formControl]="fc('tipo')">
                      <mat-option *ngFor="let tipo of enums?.tipoProduto" [value]="tipo.descricao">
                        {{ tipo.descricao }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="25" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Referência</mat-label>
                    <input [imask]="maskUpper" matInput name="referencia" type="text" [formControl]="fc('referencia')" />
                    <mat-error *ngIf="itemForm?.controls['referencia']?.hasError('required') && itemForm?.controls['referencia']?.touched">
                      Referência é obrigatória
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex="50" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Classificação Gerencial [Centro de Custo]</mat-label>
                    <mat-select #classificacaoSelect [formControl]="fc('classificacaoGerencial')" [compareWith]="compareFn" (selectionChange)="onSelectionChangeClassificacaoGerencial($event)" (openedChange)="onSelectOpenedChange('searchClassificacaoGerencial', $event)">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="fc('searchClassificacaoGerencial')" placeholderLabel="Pesquisar Classificação Gerencial..."
                          noEntriesFoundLabel="Classificação Gerencial [Centro de Custo] não encontrada" [searching]="searching"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let classificacao of classificacoesGerenciais$ | async" [value]="classificacao">
                        <span>{{ (classificacao?.codigo ?? 0).toString().padStart(5, '0') }}</span>
                        <span *ngIf="(classificacao?.classificacao || '').trim()">
                          - {{ (classificacao?.classificacao || '').trim() }}
                        </span>
                        <span> - {{ (classificacao?.descricao || '').trim() }}</span> 
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          <!-- Unidades -->
          <mat-card fxFlex="100" class="section-card">
            <mat-card-title>Unidades</mat-card-title>
            <mat-card-content>
              <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px" fxLayoutGap.lt-md="8px">
                <div fxFlex="20" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Unidade 1</mat-label>
                    <mat-select #unidadeSelect [formControl]="fc('cadUnidade1')" [compareWith]="compareFn" (selectionChange)="onSelectionChangeCadUnidade1($event)" (openedChange)="onUnidadeOpenedChange('searchUnidade1', $event)">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="fc('searchUnidade1')" placeholderLabel="Pesquisar Unidade 1..."
                          noEntriesFoundLabel="Unidade 1 não encontrada" [searching]="searching"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let cadUnidade1 of unidades$ | async" [value]="cadUnidade1">
                        {{ cadUnidade1.id }} - {{ (cadUnidade1?.descricao || '').trim() }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="itemForm?.controls['cadUnidade1']?.hasError('required') && itemForm?.controls['cadUnidade1']?.touched">
                      Unidade 1 é obrigatória
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-md="100" *ngIf="!layoutConf.isEmpresaAutomacao">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Unidade 2</mat-label>
                    <mat-select #unidadeSelect [formControl]="fc('cadUnidade2')" [compareWith]="compareFn" (selectionChange)="onSelectionChangeCadUnidade2($event)" (openedChange)="onUnidadeOpenedChange('searchUnidade2', $event)">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="fc('searchUnidade2')" placeholderLabel="Pesquisar Unidade 2..."
                          noEntriesFoundLabel="Unidade 2 não encontrada" [searching]="searching"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let cadUnidade of unidades$ | async" [value]="cadUnidade">
                        {{ cadUnidade.id }} - {{ (cadUnidade?.descricao || '').trim() }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-md="100" *ngIf="!layoutConf.isEmpresaAutomacao">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Unidade 3</mat-label>
                    <mat-select #unidadeSelect [formControl]="fc('cadUnidade3')" [compareWith]="compareFn" (selectionChange)="onSelectionChangeCadUnidade3($event)" (openedChange)="onUnidadeOpenedChange('searchUnidade3', $event)">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="fc('searchUnidade3')" placeholderLabel="Pesquisar Unidade 3..."
                          noEntriesFoundLabel="Unidade 3 não encontrada" [searching]="searching"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let cadUnidade of unidades$ | async" [value]="cadUnidade">
                        {{ cadUnidade.id }} - {{ (cadUnidade?.descricao || '').trim() }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-md="100" *ngIf="!layoutConf.isEmpresaAutomacao">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Unidade 4</mat-label>
                    <mat-select #unidadeSelect [formControl]="fc('cadUnidade4')" [compareWith]="compareFn" (selectionChange)="onSelectionChangeCadUnidade4($event)" (openedChange)="onUnidadeOpenedChange('searchUnidade4', $event)">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="fc('searchUnidade4')" placeholderLabel="Pesquisar Unidade 4..."
                          noEntriesFoundLabel="Unidade 4 não encontrada" [searching]="searching"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let cadUnidade of unidades$ | async" [value]="cadUnidade">
                        {{ cadUnidade.id }} - {{ (cadUnidade?.descricao || '').trim() }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Unidade Padrão</mat-label>
                    <mat-select #unidadeSelect [formControl]="fc('cadUnidadePadraoVenda')" [compareWith]="compareFn" (selectionChange)="onSelectionChangeCadUnidadePadraoVenda($event)" (openedChange)="onUnidadeOpenedChange('searchUnidadePadrao', $event)">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="fc('searchUnidadePadrao')" placeholderLabel="Pesquisar Unidade Padrão..."
                          noEntriesFoundLabel="Unidade Padrão não encontrada" [searching]="searching"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let cadUnidade of unidades$ | async" [value]="cadUnidade">
                        {{ cadUnidade.id }} - {{ (cadUnidade?.descricao || '').trim() }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-md="100" *ngIf="!layoutConf.isEmpresaAutomacao">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Fator Un. Conversão 1</mat-label>
                    <input matInput name="fatorunidade1" type="text" [formControl]="fc('fatorunidade1')" currencyMask
                      [options]="{ prefix: '', align: 'left', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }" />
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-md="100" *ngIf="!layoutConf.isEmpresaAutomacao">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Fator Un. Conversão 2</mat-label>
                    <input matInput name="fatorunidade2" type="text" [formControl]="fc('fatorunidade2')" currencyMask
                      [options]="{ prefix: '', align: 'left', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }" />
                  </mat-form-field>
                </div>
                <div fxFlex="20" fxFlex.lt-md="100" *ngIf="!layoutConf.isEmpresaAutomacao">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Fator Un. Conversão 3</mat-label>
                    <input matInput name="fatorunidade3" type="text" [formControl]="fc('fatorunidade3')" currencyMask
                      [options]="{ prefix: '', align: 'left', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }" />
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          <!-- Dados Específicos (Automação) -->
          <mat-card fxFlex="100" class="section-card" *ngIf="layoutConf.isEmpresaAutomacao">
            <mat-card-title>Dados Específicos (Automação)</mat-card-title>
            <mat-card-content>
              <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px" fxLayoutGap.lt-md="8px">
                <div fxFlex="50" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Tipo Produto na Composição</mat-label>
                    <mat-select [formControl]="fc('tipoProdutoAutom')">
                      <mat-option *ngFor="let tipoP of enums?.tipoProdutoAutom" [value]="tipoP.name">
                        {{ tipoP.descricao }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="50" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Bomba</mat-label>
                    <mat-select #automBombaSelect [formControl]="fc('automBomba')" (selectionChange)="onSelectionChangeAutomBomba($event)" (openedChange)="onSelectOpenedChange('searchAutomBomba', $event)">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="fc('searchAutomBomba')" placeholderLabel="Pesquisar Bomba..."
                          noEntriesFoundLabel="Bomba não encontrada" [searching]="searching"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngIf="produto?.automBomba" [value]="produto?.automBomba">
                        {{ produto?.automBomba?.codigo.toString().padStart(3, '0') }} - {{ (produto?.automBomba?.descricao || '').trim() }}
                      </mat-option>
                      <mat-option *ngFor="let bba of automBombas" [value]="bba">
                        {{ bba?.codigo.toString().padStart(3, '0') }} - {{ (bba?.descricao || '').trim() }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          <!-- Dimensões e Outros -->
          <mat-card fxFlex="100" class="section-card" *ngIf="!layoutConf.isEmpresaAutomacao">
            <mat-card-title>Dimensões e Outros</mat-card-title>
            <mat-card-content>
              <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px" fxLayoutGap.lt-md="8px">
                <div fxFlex="25" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Leiaute da Etiqueta</mat-label>
                    <mat-select [formControl]="fc('layoutEtiquetaBalanca')">
                      <mat-option *ngFor="let leiaute of enums?.layoutEtiquetaBalanca" [value]="leiaute.name">
                        {{ leiaute.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="25" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Peso Bruto (Kg)</mat-label>
                    <input matInput name="pesobruto" type="text" [formControl]="fc('pesobruto')" currencyMask
                      [options]="{ prefix: '', align: 'left', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }" />
                  </mat-form-field>
                </div>
                <div fxFlex="25" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Peso Líquido (Kg)</mat-label>
                    <input matInput name="pesoliquido" type="text" [formControl]="fc('pesoliquido')" currencyMask
                      [options]="{ prefix: '', align: 'left', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }" />
                  </mat-form-field>
                </div>
                <div fxFlex="25" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Localização</mat-label>
                    <input [imask]="maskUpper" matInput name="localizacao" type="text" [formControl]="fc('localizacao')" />
                    <mat-error *ngIf="itemForm?.controls['localizacao']?.hasError('required') && itemForm?.controls['localizacao']?.touched">
                      Localização é obrigatória
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex="25" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Largura (Cm)</mat-label>
                    <input matInput name="largura" type="text" [formControl]="fc('largura')" currencyMask
                      [options]="{ prefix: '', align: 'left', thousands: '.', allowNegative: false, decimal: ',', precision: 0 }" />
                  </mat-form-field>
                </div>
                <div fxFlex="25" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Altura (Cm)</mat-label>
                    <input matInput name="altura" type="text" [formControl]="fc('altura')" currencyMask
                      [options]="{ prefix: '', align: 'left', thousands: '.', allowNegative: false, decimal: ',', precision: 0 }" />
                  </mat-form-field>
                </div>
                <div fxFlex="25" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Profundidade (Cm)</mat-label>
                    <input matInput name="profundidade" type="text" [formControl]="fc('profundidade')" currencyMask
                      [options]="{ prefix: '', align: 'left', thousands: '.', allowNegative: false, decimal: ',', precision: 0 }" />
                  </mat-form-field>
                </div>
                <div fxFlex="25" fxFlex.lt-md="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Prazo de Entrega (Dias)</mat-label>
                    <input matInput name="prazoEntrega" type="text" [formControl]="fc('prazoEntrega')" currencyMask
                      [options]="{ prefix: '', align: 'left', thousands: '.', allowNegative: false, decimal: ',', precision: 0 }" />
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          <!-- Complemento e Dados Adicionais -->
          <mat-card fxFlex="100" class="section-card">
            <mat-card-title>Complemento e Dados Adicionais</mat-card-title>
            <mat-card-content>
              <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px" fxLayoutGap.lt-md="8px">
                <div fxFlex="100">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Complemento</mat-label>
                    <input [imask]="maskUpper" matInput name="complemento" type="text" [formControl]="fc('complemento')" />
                    <mat-error *ngIf="itemForm?.controls['complemento']?.hasError('required') && itemForm?.controls['complemento']?.touched">
                      Complemento é obrigatório
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex="100">
                  <quill-editor
                    class="dados-adicionais-editor"
                    name="dadosadicionais"
                    [formControl]="fc('dadosadicionais')"
                    placeholder="Dados adicionais"
                    theme="snow"
                    [styles]="{ height: (layoutConf.isMobile ? '180px' : '280px') }">
                  </quill-editor>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>

    <!-- Botões Inferiores -->
    <mat-card-actions *ngIf="!layoutConf.isMobile">
      <div fxFlex="100" class="action-buttons">
        <button type="button" mat-raised-button color="primary" [matTooltip]="'Salvar Produto'" (click)="save(); $event.preventDefault()">
          <mat-icon>save</mat-icon>
          <ng-container *ngIf="!layoutConf.isMobile">{{ "SAVE" | translate }}</ng-container>
        </button>
      </div>
    </mat-card-actions>
  </form>
</div>